import { Auth } from "aws-amplify";
import { useEffect } from 'react';
import Home from "../components/Home"
import { useHistory } from "react-router-dom";


export default function Logout() {
  let history = useHistory();


  useEffect(() => {
    // Update the document title using the browser API
    Auth.signOut();
    history.push("")
  });


  return ("")

}